import * as React from "react";
import { Route, Switch } from "react-router";
import { Box, Breakpoint, Stepper, StepperItem, Text } from "src/components";
import { MediaQueries } from "src/constants";
import { useTranslation } from "src/hooks";
import styled, { css } from "styled-components";
import { PASSPORT_FORM_ROUTES, PASSPORT_ROUTES } from "src/constants/routes";
import { Redirect, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { usePassportStore } from "src/stores/Passport.store";
import { observer } from "mobx-react-lite";

const SidebarEl = styled(Box)`
  ${MediaQueries.screen.large.minWidth} {
    min-width: 256px;
    max-width: 256px;
  }
`;

const ContentEl = styled(Box)`
  ${MediaQueries.screen.large.minWidth} {
    display: flex;
  }
`;

const FormContainerEl = styled(Box)`
  ${(p) =>
    p &&
    css`
      ${MediaQueries.screen.large.minWidth} {
        flex: 1 1 auto;
        border-left: 1px solid ${(p) => p.theme.colors.borders.appBar};
        padding-left: 48px;
      }
    `}
`;

export const PassportFormsScreen = observer(() => {
  const location = useLocation();
  const translate = useTranslation();
  const { outlet } = usePassportStore();

  const [activeStepperIndex, setActiveStepperIndex] = useState(0);

  useEffect(() => {
    const activeIndex = PASSPORT_FORM_ROUTES.findIndex(
      (route) => route.path === location.pathname
    );
    setActiveStepperIndex(activeIndex);
  }, [location]);

  const renderStepperItems = () =>
    PASSPORT_FORM_ROUTES.map((item) => (
      <StepperItem key={item.path} text={translate("stepper." + item.label)} />
    ));

  const sidebarTitle = outlet.isCorporateMerchant
    ? "sidebar.title.corporate"
    : "sidebar.title.individual";

  const isSidebarSubtitleExist = !!translate("sidebar.subtitle");

  return (
    <ContentEl>
      <SidebarEl marginBottomXl paddingRightM>
        <Text fontWeight="demi" fontSize="mlarge" as="h2" marginBottomS>
          {translate(sidebarTitle)}
        </Text>
        {isSidebarSubtitleExist && (
          <Text fontWeight="book" marginBottomS>
            {translate("sidebar.subtitle")}
          </Text>
        )}
        <Breakpoint large down>
          <Box marginTopXxl marginBottomXl>
            <Stepper combine activeIndex={activeStepperIndex}>
              {renderStepperItems()}
            </Stepper>
          </Box>
        </Breakpoint>
        <Breakpoint large up>
          <Box style={{ marginLeft: "-16px" }}>
            <Stepper vertical marginTopXl activeIndex={activeStepperIndex}>
              {renderStepperItems()}
            </Stepper>
          </Box>
        </Breakpoint>
      </SidebarEl>
      <FormContainerEl>
        <Switch>
          {PASSPORT_FORM_ROUTES.map(({ path, Component }) => (
            <Route key={path} path={path}>
              <Component />
            </Route>
          ))}
          <Route>
            <Redirect to={PASSPORT_ROUTES.entityType} />
          </Route>
        </Switch>
      </FormContainerEl>
    </ContentEl>
  );
});
